import React, {Component} from 'react';
import {Input,Form} from "antd";
import moment from "moment";
import BaseComponent from "../../../../base/BaseComponent";

class ViewTime extends BaseComponent {
    constructor(props) {
        super(props);
        this.state={
        }
    }
    componentDidMount() {

    }


    render() {
        let time= this.props.itemValue ? moment(this.props.itemValue).format('YYYY-MM-DD HH:mm') : '';
        return (
            <Form.Item label={this.props.label} labelCol={{span: 3}} wrapperCol={{ span: 30 }} style={{display:"flex",alignItems: "center",width:'50%',marginBottom:'0 !important'}}>
                <div>{time}</div>
            </Form.Item>
        );
    }

}

export default ViewTime